export default __webpack_public_path__ + "static/media/3017.04d4e2bd.jpg";